/**
 * Les adresses du back-office, en un seul endroit.
 *
 * `feedback.assimil.app` est l'URL que portent nos reponses aux avis des
 * boutiques : sa racine appartient donc aux gens qui nous ecrivent, et mene au
 * formulaire du site. Le back-office vit sous `/admin`.
 */

/** Racine du back-office. Le changer ici deplace toutes les entrees. */
export const ADMIN_ROOT = '/admin';

/** Le formulaire public, sur le site — plus dans cette application. */
export const PUBLIC_FORM_URL = 'https://assimil.app/support/';

export const dashboardPath = (uid?: string): string =>
    uid ? `${ADMIN_ROOT}?uid=${encodeURIComponent(uid)}` : ADMIN_ROOT;

export const feedbackPath = (id: string): string => `${ADMIN_ROOT}/feedback/${id}`;
export const bugsPath = `${ADMIN_ROOT}/bugs`;
export const bugSynthesisPath = `${ADMIN_ROOT}/bug-synthesis`;
export const teamMembersPath = `${ADMIN_ROOT}/team-members`;
export const appVersionsPath = `${ADMIN_ROOT}/app-versions`;

/**
 * Les chemins d'avant le passage sous `/admin`. Ils sont rediriges plutot que
 * supprimes : l'equipe a des favoris, et les rapports envoyes par e-mail
 * portent d'anciens liens.
 */
export const LEGACY_ADMIN_PATHS = [
    '/feedback/*',
    '/bugs',
    '/bug-synthesis',
    '/team-members',
    '/app-versions',
];
